<template>
  <base-view
      @click:config="config"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <create-edit-mensagem-dialog :item="item" 
                                :clientes-selecionados="linhasSelecionadas"
                                :search-values="searchValues"
                                v-model="editDialogOpened"
                                @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <mensagens-data-table ref="dataTable" 
                            :selection.sync="selection"
                            :search-values="searchValues"/>
    </div>
  </base-view>

</template>

<script>
import MensagensDataTable from "../../components/shared/datatables/MensagensDataTable";
import BaseView from "../BaseView";
import CreateEditMensagemDialog from "../../components/shared/dialogs/CreateEditMensagemDialog";
import {ItemDeDominio} from "../../api/itemsDominio";
import {findAll as findAllEventos} from '../../api/eventos';
import {findAll as findAllEtapas} from '../../api/etapas';
import {mapActions} from "vuex";

export default {
  name: "index",
  props: {
    
  },
  components: {CreateEditMensagemDialog, BaseView, MensagensDataTable},
  data() {
    return {
      selection: [],
      item: null,
      editDialogOpened: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Nome',
          column: 'nome',
          type: 'text'
        },
        {
          name: 'Tipo Comunicação',
          column: 'tipoComunicacao',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.ARR_TIPO_MENSAGEM
          })
        },
        {
          name: 'Mês Referência',
          column: 'mesRef',
          type: 'month'
        },        
        {
          name: 'Local',
          column: 'idLocal',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.TABELA_LOCAL
          })
        },
        {
          name: 'Sexo',
          column: 'sexo',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.ARR_SEXO
          })
        },
        {
          name: 'Status',
          column: 'status',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.STATUS_PADRAO
          })
        },
        {
          name: 'Só Matriculados',
          column: 'soMatriculados',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.FLG_PADRAO
          })
        },
        {
          name: 'Tipo Fatura',
          column: 'tipoFatura',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.ARR_TIPO_FATURA
          })
        },
        {
          name: 'Competição',
          column: 'idEvento',
          type: 'autocomplete',
          optionsFactory: (search) => findAllEventos(1, {
            nome: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          name: 'Etapa',
          column: 'idEtapa',
          type: 'autocomplete',
          optionsFactory: (search) => findAllEtapas(1, {
            nome: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          name: 'Ano Competição',
          column: 'anoCompetencia',
          type: 'text'
        },
      ]
    }
  },
  computed: {
    linhasSelecionadas() {
      return this.selection.map(s => s.idMensagem);
    }
  },
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    config() {
      this.item = {};
      this.editDialogOpened = true;
    }
  },
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>